
import { Image } from "utils"
import SETTINGS from "settings"
import { TYPE } from "network/network_api"

const kosmos = `
#define Pi 3.14159265359

float HERZ = 0.22;
float SPEED = 5.1;

//ignoring (or not even declaring) this variable crashes PIXI:
varying vec2 vTextureCoord;
//comments at uniform section are NOT working when it's under PIXI ...

uniform sampler2D uSampler;

uniform float iTime;
uniform vec2 size;

void main()
{
    vec4 b = texture2D( uSampler, vTextureCoord );

    vec2 pos = vec2( vTextureCoord.x * size.x / size.y, vTextureCoord.y );
    float l = length( pos - vec2( 0.6, 0.4 ) );
    vec3 light = vec3( 0.0, 0.0, 0.0 );
    float x = l * Pi * 2.0 / HERZ - iTime * SPEED;
    if ( x < 0.0 )
    {
        light = mix(
            light,
            vec3( 0.45, 0.45, 0.45 ),
            max( sin( x ), 0.0 )
        );
    }
    light = mix(
        light,
        vec3( 0.0, 0.0, 0.0 ),
        min( l * 2.0, 1.0 )
    );

    gl_FragColor = vec4( b.rgb + light, 1.0 );
}
`


export default function( space, container )
{
    //any image just needed to make PIXI work - couldn't run shader without any textures:
    const cloth = Image( "res/common/progressive_jackpot/galaxy_background.jpg" )
    cloth.width = SETTINGS.canvas.width
    cloth.height = SETTINGS.canvas.height

    const shader = new PIXI.Filter(
        null,
        kosmos
    )
    shader.uniforms.iTime = 0.0
    shader.uniforms.size = [ 0, 0 ]
    space.s( "ticker" )
        .with( space.s( "state" ), ( seconds, state ) => ({ seconds, state }) )
        .on( ({ seconds, state }) => {
            if ( state.type == TYPE.PROGRESSIVE_JACKPOT && state.state.stage.math.jackpot_progressive.type_id == 9 )
            {
                shader.uniforms.iTime += seconds
            }
            else
            {
                shader.uniforms.iTime = 0
            }
        } )
    space.s( "size" ).on( ({ x, y }) => shader.uniforms.size = [ x, y ] )

    cloth.filters = [ shader ]
    container.addChild( cloth )
}



// WEBPACK FOOTER //
// ./src/library/progressive_jackpot/kosmos.es6